import { Entity } from '@nx-data/nx-data';
import { buildAndDefineMetaMap, ClassType, getMetaMapValues } from '@nx-data/utilities';

/* eslint-disable prefer-arrow/prefer-arrow-functions */

export interface EntityDecoratorProps {
  entityTtlMs: number; // How long should be reused before expiring (and requesting a new)
}

const defaultEntityConfig: EntityDecoratorProps = {
  entityTtlMs: 1000 * 60 * 5,
};

const metadataKey = Symbol('Entity');

export function NxTable(metadata: EntityDecoratorProps = { ...defaultEntityConfig }) {
  return function (target: object, propertyKey: string) {
    buildAndDefineMetaMap(metadataKey, target, propertyKey, metadata || { ...defaultEntityConfig });
  };
}

export function getTableConfigForEntity<T extends Entity>(classType: ClassType<T>): EntityDecoratorProps {
  return getMetaMapValues<EntityDecoratorProps>(metadataKey, classType.prototype).firstOrNull() ?? { ...defaultEntityConfig };
}
